import React, { useEffect, useState } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';

import { CustomPagination } from 'common/components';

import { getColumnsFromSeries, getRowsFromSeries } from '../helpers';

const MeasuredEnergyTable = ({
    categories,
    countryCurrencyLocale,
    isFetching,
    series,
    viewOption,
}) => {
    const [tableContent, setTableContent] = useState({
        rows: [],
        columns: [],
    });

    const pageSizeOptions = [12];

    const slotProps = {
        pagination: { pageSizeOptions },
    };
    const slots = { pagination: CustomPagination };

    useEffect(() => {
        setTableContent({
            rows: getRowsFromSeries(series, categories),
            columns: getColumnsFromSeries(
                series,
                viewOption,
                countryCurrencyLocale,
            ),
        });
    }, [series, categories]);

    return (
        <DataGrid
            checkboxSelection={false}
            columns={tableContent.columns}
            disableColumnMenu
            disableRowSelectionOnClick
            hideFooterSelectedRowCount
            loading={isFetching}
            pageSizeOptions={pageSizeOptions}
            pagination
            paginationMode="client"
            rows={tableContent.rows}
            slotProps={slotProps}
            slots={slots}
        />
    );
};

MeasuredEnergyTable.propTypes = {
    categories: PropTypes.array,
    countryCurrencyLocale: PropTypes.string,
    isFetching: PropTypes.bool,
    series: PropTypes.array,
    viewOption: PropTypes.number,
};

export default MeasuredEnergyTable;
